<template>
  <div>
    <div class="modal-header">
      <h2>Nov račun</h2>
    </div>
    <div class="body-invoice">
      <div class="input-wrapper" v-if="step == 1">
        <div class="expenses-input-wrapper">
          <div class="add-expense-desc">
            Dodaj stavku računa
            <span
              rel="popover"
              data-placement="left"
              data-content="foobar baz zoo doo"
            >
              <i
                class="fas fa-info-circle expense-tooltip"
                title="Da biste dodali predefinisanu stavku potrebno je kliknuti na nju i potom uneti količinu."
              ></i>
            </span>
          </div>
          <div class="input-fields">
            <div class="field-name">
              <input
                type="text"
                class="form-control form-control-lg input--name"
                v-model="expenseName"
                @focus="clearErrorLog('expenseName')"
                :class="{
                  'border-red': errorLog.expenseName
                }"
                placeholder=" "
              />
              <span class="input-span input-span--name">Stavka</span>
            </div>
            <div class="field-amount remove-number-arrows">
              <input
                type="number"
                ref="expenseQuantity"
                v-model="expenseQuantity"
                @focus="clearErrorLog('expenseQuantity')"
                class="form-control form-control-lg input--amount"
                :class="{
                  'border-red': errorLog.expenseQuantity
                }"
                placeholder=" "
                v-on:keyup.enter="addInvoiceItem"
              />
              <span class="input-span input-span--amount">Količina</span>
            </div>
            <div class="field-price remove-number-arrows">
              <input
                type="text"
                v-model.lazy="expensePrice"
                v-money="{}"
                @focus="clearErrorLog('expensePrice')"
                class="form-control form-control-lg input--price"
                :class="{
                  'border-red': errorLog.expensePrice
                }"
                placeholder=" "
              />
              <span class="input-span input-span--price">Cena</span>
            </div>
          </div>
          <button class="btn btn-primary btn--add" @click="addInvoiceItem">DODAJ</button>
          <div class="predefined-expenses">
            <div class="text-secondary">*Izaberite stavku koju želite da dodate</div>
            <mini-table
              :columns="predefinedExpensesColumns"
              :data="predefinedExpensesData"
              :emitRowOnClick="true"
              :height="145"
              @rowClick="fulfillExpenseData"
              v-if="!isLoading"
            ></mini-table>
            <spinner line-fg-color="#00796b" :size="40" v-if="isLoading" />
          </div>
        </div>
        <div class="expenses-preview">
          <div class="add-expense-desc">Dodate stavke računa</div>
          <mini-table
            :columns="previewExpensesColumns"
            :data="previewExpensesData"
            @rowClick="fulfillExpenseData"
            @remove="handleRemoveItem"
            :showTrashCan="true"
            :height="265"
          ></mini-table>
          <div class="total-wrapper">UKUPNO: {{ totalExpenses | addSeparator }}</div>
        </div>
      </div>
      <div class="members-wrapper" v-if="step == 2">
        <div class="members-control">
          <input
            type="text"
            placeholder="Pretraga stanara"
            v-model="searchCriteria"
            class="form-control form-control-lg search-input"
          />
          <button class="btn btn-primary btn-add" @click="selectAll">Izaberi sve stanare</button>
          <button class="btn btn-primary btn-add" @click="deselectAll">Poništi izbor</button>
        </div>
        <div class="members">
          <mini-table
            :columns="memberColumns"
            :data="getFilteredMembers"
            :height="320"
            :checkable="true"
          ></mini-table>
          <div class="total-wrapper">Selektovano {{ numOfSelected }} / {{ memberData.length }}</div>
        </div>
      </div>
      <div class="invoice-details" v-if="step == 3">
        <div class="actions-section">
          <h4 class="heading">Akcije</h4>
          <checkbox
            label="Pošalji e-mail članovima"
            size="normal"
            class="custom-cb"
            :checked="sendMails"
            @change.native="sendMails = !sendMails"
          ></checkbox>
          <checkbox
            label="Postavi objavu u zajednicu"
            size="normal"
            class="custom-cb"
            :checked="createPost"
            @change.native="createPost = !createPost"
          ></checkbox>
          <span rel="popover" data-placement="left">
            <i class="fas fa-info-circle expense-tooltip" :title="getPostDescription"></i>
          </span>

          <div class="print_opt">
            <label class="container">
              Bez štampanja
              <input type="radio" name="radio" value="none" v-model="printOption" />
              <span class="checkmark"></span>
            </label>
            <label class="container">
              Štampaj za sve članove
              <input
                type="radio"
                name="radio"
                value="all"
                v-model="printOption"
              />
              <span class="checkmark"></span>
            </label>
            <label class="container">
              Štampaj za članove koji nemaju aplikaciju
              <input
                type="radio"
                name="radio"
                value="onlyWithoutApp"
                v-model="printOption"
              />
              <span class="checkmark"></span>
            </label>
          </div>
        </div>

        <div class="details-input">
          <div class="row-wrapper margin-bottom">
            <div class="description-input">
              <label for="desc" class="desc">
                Opis
                <span class="mandatory">*</span>
              </label>
              <input
                class="form-control form-control-lg description-input"
                :class="{
                  'border-red': errorLog.description
                }"
                type="text"
                id="desc"
                @focus="errorLog.description = false"
                v-model="description"
              />
            </div>
          </div>
          <div class="row-wrapper margin-bottom">
            <div class="row-item">
              <label for="issue-date" class="desc">
                Datum izdavanja
                <span class="mandatory">*</span>
              </label>
              <datetime
                ref="datetime"
                type="date"
                @input="handleDatetimeInput"
                :phrases="{
                  ok: 'U redu',
                  cancel: 'Otkaži'
                }"
                format="dd/MM/yyyy"
                v-model="issueDate"
              ></datetime>
              <div
                class="form-control form-control-lg datetime-mask"
                :class="{
                  'border-red': errorLog.issueDate
                }"
                type="text"
                id="issue-date"
                @click="handleDatetimeClick"
              >
                {{ issueDate | formatDate }}
                <i class="far fa-calendar-alt calendar--mod"></i>
              </div>
            </div>
            <div class="row-item">
              <label for="accounting-period" class="desc">
                Obračunski period
                <span class="mandatory">*</span>
              </label>

              <input
                class="form-control form-control-lg"
                :class="{
                  'border-red': errorLog.accountingPeriod
                }"
                type="text"
                v-model="accountingPeriod"
                id="accounting-period"
                @focus="clearErrorLog('accountingPeriod')"
              />
            </div>
          </div>
          <div class="row-wrapper margin-bottom">
            <div class="row-item">
              <label for="expiration-date" class="desc">
                Rok plaćanja
                <span class="mandatory">*</span>
              </label>
              <datetime
                ref="datetimePayment"
                type="date"
                @input="handleDatetimeInputPaymentPeriod"
                :phrases="{
                  ok: 'U redu',
                  cancel: 'Otkaži'
                }"
                format="dd/MM/yyyy"
                v-model="paymentDeadline"
              ></datetime>
              <div
                class="form-control form-control-lg datetime-mask"
                type="text"
                id="issue-date"
                @click="handleDatetimeClickPaymentPeriod"
              >
                {{ paymentDeadline | formatDate }}
                <i class="far fa-calendar-alt calendar--mod"></i>
              </div>
              <!-- <input
                class="form-control form-control-lg"
                :class="{
                  'border-red': errorLog.paymentDeadline
                }"
                type="text"
                v-model="paymentDeadline"
                id="expiration-date"
                @focus="clearErrorLog('paymentDeadline')"
              />-->
            </div>
            <div class="row-item">
              <label for="invoice-num" class="desc">
                Broj računa
                <span class="mandatory">*</span>
              </label>
              <input
                class="form-control form-control-lg"
                :class="{
                  'border-red': errorLog.invoiceNum
                }"
                type="text"
                v-model="invoiceNum"
                id="invoice-num"
                @focus="clearErrorLog('invoiceNum')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="footer">
      <transition enter-active-class="animated shake">
        <p class="error" v-if="errorMessage.length > 0">{{ errorMessage }}</p>
      </transition>
      <div class="screen1" v-if="step == 1">
        <div class="buttons">
          <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">Otkaži</button>
          <button type="submit" class="btn btn-primary btn--mod" @click="goToSelectMemebers">Dalje</button>
        </div>
      </div>
      <div class="screen2" v-if="step == 2">
        <div class="buttons">
          <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">Otkaži</button>
          <button type="submit" class="btn btn-primary btn--mod" @click="step--">Nazad</button>
          <button type="submit" class="btn btn-primary btn--mod" @click="goToInvoiceDetails">Dalje</button>
        </div>
      </div>
      <div class="screen3" v-if="step == 3">
        <div class="buttons">
          <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">Otkaži</button>
          <button type="submit" class="btn btn-primary btn--mod" @click="step--">Nazad</button>
          <button type="button" class="btn btn-primary btn--mod" :disabled="loading" @click="save">
            <p v-if="!loading">Sačuvaj</p>
            <spinner class="spinner" :size="20" line-fg-color="#00796b" v-if="loading" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import miniTable from '../ModalFinancesTable';
import checkbox from '@/components/common/Checkbox.vue';
import { financesInstance } from '@/axios/axios.js';
import axios from '@/axios/axios.js';
import { addSeparatorMixin, formatDateMixin } from '@/mixins/mixins.js';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { Settings, DateTime } from 'luxon';

export default {
  name: 'invoiceModal',
  created() {
    document.addEventListener('keydown', this.processKeyboardEvent);
    Settings.defaultLocale = 'sr-Latn-CS';
    this.isLoading = true;
    const months = [
      'Januar',
      'Februar',
      'Mart',
      'April',
      'Maj',
      'Jun',
      'Jul',
      'Avgust',
      'Septembar',
      'Octobar',
      'Novembar',
      'Decembar'
    ];
    const now = new Date();
    const thisMonth = months[now.getMonth()];
    // this.description = 'Račun za mesec ' + thisMonth + " " + now.getFullYear() + ".";
    this.description = `Račun za mesec ${thisMonth} ${now.getFullYear()}.`;
    financesInstance
      .get(
        `communities/${
          this.$store.getters.getActiveCommunity.community_id
        }/members`
      )
      .then(({ data }) => {
        let members = [];
        let ordinal = 1;
        for (let member of data.members) {
          member.checked = true;
          member.description = member.div_description;
          member.name = member.full_name;
          member.ordinal = ordinal++;
          members.push(member);
        }
        this.memberData = members;
      });

    financesInstance
      .get(
        `communities/${
          this.$store.getters.getActiveCommunity.community_id
        }/expenses`
      )
      .then(res => {
        this.predefinedExpensesData = res.data.expenses;
        this.isLoading = false;
      });
  },
  components: {
    miniTable,
    checkbox,
    datetime: Datetime
  },
  mixins: [addSeparatorMixin, formatDateMixin],
  computed: {
    ...mapState('finances', ['invoices']),
    numOfSelected() {
      let num = 0;
      for (let member of this.memberData) {
        if (member.checked) {
          num++;
        }
      }
      return num;
    },
    getPostDescription() {
      return 'Poštovane komšije, kreairan je ' + this.description.toLowerCase();
    },
    getFilteredMembers() {
      if (this.searchCriteria === '') {
        return this.memberData;
      } else {
        return this.memberData.filter(member => {
          if (
            member.name
              .toLowerCase()
              .includes(this.searchCriteria.toLowerCase()) ||
            member.description
              .toLowerCase()
              .includes(this.searchCriteria.toLowerCase())
          ) {
            return member;
          }
        });
      }
    }
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapActions('finances', [
      'getTableData',
      'getAccountDetails',
      'setVirtualMembersList'
    ]),
    ...mapMutations('finances', ['setVirtualMembersList']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('table', ['getAllMembersForCommunityFinances']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    selectAll() {
      for (let member of this.memberData) {
        member.checked = true;
      }
    },
    handleDatetimeInput(value) {
      if (value == '') {
        this.issueDate = new Date().toISOString();
      } else {
        this.issueDate = value;
      }
    },
    handleDatetimeInputPaymentPeriod(value) {
      if (value == '') {
        this.paymentDeadline = new Date().toISOString();
      } else {
        this.paymentDeadline = value;
      }
    },
    handleDatetimeClick() {
      this.clearErrorLog('issueDate');
      this.$refs.datetime.$el.querySelector('.vdatetime-input').focus();
    },
    handleDatetimeClickPaymentPeriod() {
      this.$refs.datetimePayment.$el.querySelector('.vdatetime-input').focus();
    },
    deselectAll() {
      for (let member of this.memberData) {
        member.checked = false;
      }
    },
    goToSelectMemebers() {
      if (!this.validateExpenses()) {
        this.errorMessage = 'Morate uneti bar jednu stavku računa';
        this.loading = false;
        return;
      }
      this.step++;
    },
    goToInvoiceDetails() {
      if (this.numOfSelected == 0) {
        this.errorMessage = 'Morate izabrati bar jednog stanara';
        this.loading = false;
        return;
      }
      this.errorMessage = '';
      this.step++;
    },
    save() {
      this.loading = true;
      if (!this.validateInputs()) {
        this.loading = false;
        return;
      }
      if (!this.validateInputsLength()) {
        this.loading = false;
        return;
      }

      let memberIds = [];
      for (let member of this.memberData) {
        if (member.checked) {
          memberIds.push(member.id);
        }
      }

      let invoiceItems = [];

      for (let expense of this.previewExpensesData) {
        invoiceItems.push(expense);
      }

      let timestamp = new Date();

      let data = {
        memberIds: memberIds,
        timestamp: timestamp,
        invoiceItems: invoiceItems,
        description: this.description,
        paymentPeriod: this.paymentDeadline,
        accountingPeriod: this.accountingPeriod,
        invoiceNumber: this.invoiceNum,
        issueDate: this.issueDate
      };

      financesInstance
        .post('members/invoices', data)
        .then(async res => {
          // this.loading = false;
          if (this.sendMails) {
            try {
              await this.sendMailsToMembers(res.data.invoiceId, memberIds);
            } catch (err) {
              console.log(err);
            }
          }
          if (this.printOption != 'none') {
            try {
              await this.downloadPdfs(
                res.data.invoiceId,
                memberIds,
                this.printOption
              );
            } catch (error) {
              console.log(error);
            }
          }

          if (this.createPost) {
            try {
              await this.createInvoicePost();
            } catch (err) {
              console.log(err);
            }
          }

          this.refreshData();

          this.closeModal();
          this.showSuccessModal();
        })
        .catch(err => {
          console.log(err);
          this.showFailModal();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadPdfs(invoiceId, memberIds, printOption) {
      let sendOnlyToNonAppMembers = false;
      if (printOption == 'onlyWithoutApp') {
        sendOnlyToNonAppMembers = true;
      }
      return financesInstance
        .post(
          '/members/invoicesInPdf',
          {
            invoiceId: invoiceId,
            memberIds: memberIds,
            sendOnlyToNonAppMembers: sendOnlyToNonAppMembers
          },
          {
            responseType: 'blob'
          }
        )
        .then(({ data }) => {
          let fileURL = window.URL.createObjectURL(new Blob([data]));
          let fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', this.description + '.pdf');
          document.body.appendChild(fileLink);

          fileLink.click();
        });
    },
    createInvoicePost() {
      return axios.post('post', {
        body: this.getPostDescription,
        community_id: this.$store.getters.getActiveCommunity.id,
        member_id: this.$store.getters.getActiveCommunity.member_id,
        post_type: 1
      });
    },
    sendMailsToMembers(invoiceId, memberIds) {
      return financesInstance.post('/members/sendInvoiceToMail', {
        invoiceId: invoiceId,
        memberIds: memberIds
      });
    },
    async refreshData() {
      await this.getTableData({
        communityId: this.$store.getters.getActiveCommunity.id,
        tableName: 'invoices'
      });
      if (this.$router.history.current.name !== 'communityFinancesHome') {
        this.setTableData(this.invoices.data);
      } else {
        const virtualMembers = await this.getAllMembersForCommunityFinances(
          this.$store.getters.getActiveCommunity.id
        );

        this.setVirtualMembersList(virtualMembers);

        this.getAccountDetails();
      }
    },
    processKeyboardEvent(e) {
      if (e.key === 'Escape') {
        this.closeModal();
      }
    },
    doesErrorExist() {
      return (
        this.checkIfEmpty('expenseName') ||
        this.checkIfEmpty('expenseQuantity') ||
        this.checkIfEmpty('expensePrice') ||
        this.numberFieldsContainNegatives()
      );
    },
    areFieldsEmpty() {
      return (
        this.expenseName === '' ||
        this.expenseQuantity === '' ||
        this.expensePrice === ''
      );
    },
    numberFieldsContainNegatives() {
      let containsNegatives =
        this.expenseQuantity <= 0 || this.expensePrice <= 0;
      if (containsNegatives) {
        this.errorMessage = 'Količina/cena ne smeju imati negativnu vrednost';
      }
      return containsNegatives;
    },
    validateInputs() {
      return (
        this.validateExpenses() &&
        this.validateMembers() &&
        !this.checkIfEmpty('description') &&
        !this.checkIfEmpty('issueDate') &&
        !this.checkIfEmpty('accountingPeriod') &&
        !this.checkIfEmpty('paymentDeadline') &&
        !this.checkIfEmpty('invoiceNum')
      );
    },
    validateInputsLength() {
      return (
        !this.checkFiledLength('description') &&
        !this.checkFiledLength('issueDate') &&
        !this.checkFiledLength('accountingPeriod') &&
        !this.checkFiledLength('paymentDeadline') &&
        !this.checkFiledLength('invoiceNum')
      );
    },
    validateExpenses() {
      return this.previewExpensesData.length !== 0;
    },
    validateMembers() {
      let counter = 0;
      for (let member of this.memberData) {
        if (member.checked) {
          counter++;
        }
      }
      return counter !== 0;
    },
    clearErrorLog(field) {
      this.errorLog[field] = false;
      this.errorMessage = '';
    },
    checkIfEmpty(field) {
      if (this[field].length === 0) {
        this.errorLog[field] = true;
        this.errorMessage = `Polje ${
          this.fieldsTranslations[field]
        } je obavezno`;
        return true;
      }
      return false;
    },
    checkFiledLength(field) {
      if (this[field].length > 80) {
        this.errorLog[field] = true;
        this.errorMessage = `Polje ${
          this.fieldsTranslations[field]
        } može imati najviše 80 karaktera`;
        return true;
      }
      return false;
    },
    validateDescription() {
      if (this.description.length === 0) {
        this.descriptionError = true;
        return false;
      }
      return true;
    },
    fulfillExpenseData(expense) {
      this.expenseQuantity = '';
      this.expenseName = expense.name;
      this.expensePrice = expense.price * 100;
      this.$refs.expenseQuantity.focus();
    },
    addInvoiceItem() {
      if (this.doesErrorExist()) {
        return;
      }
      if (this.expenseName.length > 80) {
        this.errorLog['expenseName'] = true;
        this.errorMessage = 'Naziv stavke ne može imati preko 80 karaktera';
        return;
      }

      let price = parseFloat(
        parseFloat(this.expensePrice.replace(/,/g, '')).toFixed(2)
      );
      let total = (price * parseFloat(this.expenseQuantity)).toFixed(2);
      let item = {
        ordinal: this.previewExpensesData.length + 1,
        name: this.expenseName,
        quantity: parseFloat(this.expenseQuantity),
        price: price,
        total: total
      };
      this.totalExpenses += parseFloat(item.total);
      this.totalExpenses = parseFloat(this.totalExpenses.toFixed(2));
      this.previewExpensesData.push(item);
      this.clearInputs();
    },
    handleRemoveItem(item) {
      this.totalExpenses -= parseFloat(item.total);
      this.totalExpenses = parseFloat(this.totalExpenses.toFixed(2));
      this.previewExpensesData.splice(item.ordinal - 1, 1);
      let ordinal = 1;
      for (let item of this.previewExpensesData) {
        item.ordinal = ordinal++;
      }
    },
    clearInputs() {
      this.expensePrice = '';
      this.expenseName = '';
      this.expenseQuantity = '';
    }
  },
  data() {
    return {
      step: 1,
      errorMessage: '',
      searchCriteria: '',
      expenseName: '',
      expensePrice: '',
      expenseQuantity: '',
      issueDate: '',
      accountingPeriod: '',
      paymentDeadline: '',
      invoiceNum: '',
      totalExpenses: 0,
      errorLog: {
        description: false,
        issueDate: false,
        accountingPeriod: false,
        paymentDeadline: false,
        invoiceNum: false,
        expenseName: false,
        expenseQuantity: false,
        expensePrice: false
      },
      descriptionError: false,
      description: '',
      loading: false,
      screenOne: true,
      isLoading: false,
      sendMails: false,
      createPost: false,
      fieldsTranslations: {
        issueDate: 'datum izdavanja',
        accountingPeriod: 'obračunski period',
        paymentDeadline: 'rok plaćanja',
        invoiceNum: 'broj računa',
        expenseName: 'stavka',
        expenseQuantity: 'količina',
        expensePrice: 'cena',
        description: 'opis'
      },
      printOption: 'none',
      memberColumns: [
        { key: 'ordinal', label: 'rBr', flex: 1 },
        { key: 'name', label: 'Ime i prezime', flex: 2 },
        { key: 'description', label: 'Opis', flex: 2 },
        { key: 'id', label: 'Poziv na broj', flex: 1 }
      ],
      memberData: [],
      previewExpensesColumns: [
        { key: 'ordinal', label: 'rBr', flex: 1 },
        { key: 'name', label: 'Stavka računa', flex: 2 },
        { key: 'quantity', label: 'Kolicina', flex: 2 },
        { key: 'price', label: 'Cena', flex: 2 },
        { key: 'total', label: 'Ukupno', flex: 2 }
      ],
      previewExpensesData: [],
      predefinedExpensesColumns: [
        { key: 'name', label: 'Stavka računa', flex: 5 },
        { key: 'price', label: 'Cena', flex: 1 }
      ],
      predefinedExpensesData: []
    };
  },
  destroyed() {
    document.removeEventListener('keydown', this.processKeyboardEvent);
  }
};
</script>

<style lang="scss">
.body-invoice {
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  // min-height: 430px;
  // height: 430px;
  height: 62vh;

  .input-wrapper {
    height: 100%;
    display: flex;
    width: 100%;
    padding: 1rem 0;

    .expenses-input-wrapper {
      padding-right: 1rem;
      margin-right: 1rem;
      border-right: 1px solid #e9ecef;
      height: 100%;
      width: 55%;

      .input-fields {
        display: flex;
        align-items: center;
        padding-left: 1.5px;
        div:not(:last-child) {
          margin-right: 0.7rem;
        }

        .field-name {
          flex: 1;
          position: relative;
          .input--name:focus ~ .input.span--name,
          .input--name:not(:placeholder-shown) ~ .input-span--name {
            transform: scale(0.75) translateY(-50px) translateX(-30px);
          }
        }

        .field-amount {
          flex: 1;
          position: relative;
          .input--amount:focus ~ .input.span--amount,
          .input--amount:not(:placeholder-shown) ~ .input-span--amount {
            transform: scale(0.75) translateY(-50px) translateX(-30px);
          }
        }

        .field-price {
          flex: 1;
          position: relative;
          .input--price:focus ~ .input.span--price,
          .input--price:not(:placeholder-shown) ~ .input-span--price {
            transform: scale(0.75) translateY(-50px) translateX(-30px);
          }
        }
      }

      .input-span {
        position: absolute;
        font-size: 1.3rem;
        color: rgb(95, 95, 95);
        top: 0.6rem;
        left: 1rem;
        pointer-events: none;
        transition: 0.2s all;
      }

      .btn--add {
        margin: 1rem 0;
        width: 100%;
        font-size: 1.2rem;
      }

      .btn--add:active,
      .btn--add:focus {
        box-shadow: none !important;
      }

      .predefined-expenses {
        max-height: 15rem;
        min-height: 10rem;
        height: calc(100% - 126px);
        width: 100%;
      }
    }
  }
  .expenses-preview {
    width: 45%;
    position: relative;
  }

  .members-wrapper {
    height: 100%;
    display: flex;

    .members-control {
      width: 30%;
      padding-right: 1rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      margin-right: 1rem;
      border-right: 1px solid #e9ecef;
      padding-left: 2px;
      .search-input {
        width: 100%;
        height: 70px;
        border: none;
        border-radius: 0;
        margin-bottom: 1rem;
        -webkit-transition: 0.5s border-bottom;
        transition: 0.5s border-bottom;
        background-color: #eeeeee;
        box-shadow: none;
        border-bottom: 2px solid transparent;
      }

      .search-input:focus {
        border-color: var(--primary-color);
        box-shadow: none;
      }

      button {
        margin-bottom: 1rem;
      }
    }

    .members {
      width: 70%;
      position: relative;
    }
  }
  .total-wrapper {
    position: absolute;
    right: 0;
    bottom: 0;
    font-size: 1.2rem;
    font-weight: 900;
  }

  .border-red {
    border-color: red !important;
  }
}

.add-expense-desc {
  margin-bottom: 25px;
  font-size: 1.2rem;
}

.desc {
  font-size: 18px;
  display: inline-flex;
}
.expense-tooltip {
  color: rgba(0, 0, 0, 0.521);
  font-size: 1rem;
  vertical-align: top;
}

.expense-tooltip:hover {
  color: rgb(245, 163, 13);
}

.invoice-details {
  height: 100%;
  display: flex;
  .actions-section {
    width: 35%;
    border-right: 1px solid #e9ecef;
    height: 100%;
    .heading {
      margin-bottom: 0.8rem;
    }
    .custom-cb:last-of-type {
      padding-bottom: 1rem;
      margin-bottom: 1rem;
      margin-right: 5px;
      border-bottom: 1px solid #e9ecef;
    }
  }
  .details-input {
    padding: 0 10%;
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .row-wrapper {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    .description-input {
      width: 100%;
    }

    .row-item {
      width: 45%;
    }
    .margin-bottom {
      margin-bottom: 1.5rem;
    }

    .datetime-mask {
      position: relative;

      .calendar--mod {
        position: absolute;
        right: 10px;
        bottom: 12px;
        color: #989899;
      }
    }

    .datetime-mask:hover {
      cursor: text;
    }

    .vdatetime-input {
      opacity: 0;
      position: absolute;
    }
  }

  .print_opt {
    .container {
      display: block;
      position: relative;
      padding-left: 35px;
      margin-bottom: 5px;
      cursor: pointer;
      font-size: 18px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    /* Hide the browser's default radio button */
    .container input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    /* Create a custom radio button */
    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 25px;
      width: 25px;
      background-color: #eee;
      border-radius: 50%;
    }

    /* On mouse-over, add a grey background color */
    .container:hover input ~ .checkmark {
      background-color: #ccc;
    }

    /* When the radio button is checked, add a blue background */
    .container input:checked ~ .checkmark {
      background-color: var(--primary-color);
    }

    /* Create the indicator (the dot/circle - hidden when not checked) */
    .checkmark:after {
      content: '';
      position: absolute;
      display: none;
    }

    /* Show the indicator (dot/circle) when checked */
    .container input:checked ~ .checkmark:after {
      display: block;
    }

    /* Style the indicator (dot/circle) */
    .container .checkmark:after {
      top: 9px;
      left: 9px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: white;
    }
  }
}

.remove-number-arrows {
  input[type='number'] {
    -moz-appearance: textfield;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
}

hr {
  margin-top: 0;
}

.relative {
  position: relative;
}

.error {
  color: red;
  float: left;
  margin: 0 auto;
  margin-left: 1rem;
  display: flex;
  align-items: center;
  p {
    margin: 0;
  }
}

.footer {
  width: 100%;
  position: relative;

  .screen2 {
    .spinner {
      margin-top: 0;
    }
  }

  .buttons {
    float: right;

    .btn--mod {
      height: 35px;
      min-width: 75px;
      margin-left: 5px;
      align-self: center;
    }

    button {
      position: relative;
    }

    button:disabled {
      background-color: var(--primary-color-lighten);
    }
  }
}
.mandatory {
  color: red;
  margin-left: 3px;
}
</style>
